import { styled as muiStyled } from '@mui/material'

export const CH4 = muiStyled('div')(
  ({ theme }) => `
font-size: calc(1.275rem + 0.3vw);
font-family: "Outfit";
margin-bottom: 0.5rem;
font-weight: 500;
`,
)

export const CStrong = muiStyled('strong')(
  ({ theme }) => `
font-weight: 700;
font-family: "Outfit" !important;
`,
)

export const CHeading1 = muiStyled('h1')(
  ({ theme }) => `
font-size: calc(1.375rem + 1.5vw);
`,
)

export const CHeading2 = muiStyled('h2')(
  ({ theme }) => `
font-size: calc(1.325rem + 0.9vw);
`,
)
export const CHeading3 = muiStyled('h2')(
  ({ theme }) => `
  font-size: calc(1.3rem + 0.6vw);
`,
)

export const CHeading5 = muiStyled('h5')(
  ({ theme }) => `
font-size: 1.25rem;
`,
)
